import React from "react";
import PropTypes from "prop-types";
import { sortBy, filter, get, map } from "lodash";

import Grid from "@material-ui/core/Grid";

import InfoSection from "../../Common/InfoSection";
import MultipleInfoSection from "./MultipleInfoSection";

import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";
import { displayBoolean } from "../../../utils/data";

import { LANGUAGES } from "../../../constants/common";

const VehicleView = (props) => {
  const {
    profileType,
    section,
    data,
    lov,
    language,
    profileAttributes,
  } = props;

  if (section === "main") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );

    return (
      <>
        <Grid container>
          <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(18)}
                values={[getAttributeValue(data, 18)]}
              />
              <InfoSection
                title2={getAttributeName(profileType === 2 ? 42 : 53)}
                values={[
                  getAttributeValue(data, profileType === 2 ? 42 : 53, lov),
                ]}
              />
              <InfoSection
                title="tag"
                values={data.tag ? [data.tag[`name_${language}`]] : []}
                color={data.tag ? data.tag.color_rgb : ""}
              />
            </Grid>
          </Grid>
          <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(89)}
                values={[getAttributeValue(data, 89, lov)]}
              />
              <InfoSection
                title2={getAttributeName(45)}
                values={[getAttributeValue(data, 45)]}
              />
              <InfoSection
                title2={getAttributeName(46)}
                values={[getAttributeValue(data, 46)]}
              />
            </Grid>
          </Grid>
          <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(44)}
                values={[getAttributeValue(data, 44)]}
              />
            </Grid>
          </Grid>
          <Grid item style={{ width: "400px" }}>
            <Grid container direction="column">
              <MultipleInfoSection
                title2={getAttributeName(50)}
                values={getAttributeValues(data, 50)}
                typeId={135}
                language={language}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => {
            return [51,52].includes(attr.id)?null:
            <InfoSection
              key={attr.id}
              style={{ width: "204px" }}
              title2={getAttributeName(attr.id)}
              values={[
                attr.data_type === "boolean"
                  ? displayBoolean(
                      getAttributeValue(data, attr.id, lov, language)
                    )
                  : getAttributeValue(data, attr.id, lov, language),
              ]}
            />
            })}
        </Grid>
      </>
    );
  }

  if (section === "secondary") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );

    return (
      <>
        <Grid container>
          {/* <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(51)}
                values={[getAttributeValue(data, 51)]}
              />
              <InfoSection
                title2={getAttributeName(52)}
                values={[getAttributeValue(data, 52)]}
              />
            </Grid>
          </Grid> */}
          <Grid item style={{ width: "220px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(47)}
                values={[getAttributeValue(data, 47)]}
              />
              <InfoSection
                title2={getAttributeName(104)}
                values={[getAttributeValue(data, 104)]}
              />
            </Grid>
          </Grid>
          <Grid item style={{ width: "400px" }}>
            <Grid container direction="column">
              <InfoSection
                title2={getAttributeName(19)}
                values={[getAttributeValue(data, 19)]}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => {
            return attr.id === 135 ? null : <InfoSection
              key={attr.id}
              style={{ width: "220px" }}
              title2={getAttributeName(attr.id)}
              values={[
                attr.data_type === "boolean"
                  ? displayBoolean(
                      getAttributeValue(data, attr.id, lov, language)
                    )
                  : getAttributeValue(data, attr.id, lov, language),
              ]}
            />
            })}
        </Grid>
      </>
    );
  }
  return null;
};

VehicleView.propTypes = {
  profileType: PropTypes.oneOf([2, 3]),
  section: PropTypes.oneOf(["main", "secondary"]),
  data: PropTypes.object,
  lov: PropTypes.object,
  language: PropTypes.oneOf(LANGUAGES),
};

export default VehicleView;
